var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"nav-item",class:{active: _vm.isActive}},[_c('a',{staticClass:"nav-link font-semibold",attrs:{"href":_vm.href}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }